var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders-page"},[_c('ordersList',_vm._l((_vm.ordersList),function(order,index){return _c('OrderItem',{key:'order' + index,attrs:{"order":order}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }